import { EMPTY_TEXT } from '@mitchell/react.component.ux';
import { PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_FAILURE, PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_SUCCESS, PHOTO_CAPTURE_INTELLIGENT_RESET_IMAGE_ANALYZER_DETAILS } from '../actions';
import { SERVICE_FAIL_STATUS } from '../constants';
import { IntelligentPhotoCaptureViewType } from '../enums';
import { determineStateView, hasImageQualityAnalysisIsClear } from '../utilities';
export const photoCaptureIntelligentImageDetailsReducer = (state, action) => {
    switch (action.type) {
        case PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_SUCCESS: {
            const results = action.payload.photoCaptureImageData.results;
            let imageDetailPayload = {};
            let errorMessage = EMPTY_TEXT;
            let shouldShowIQAErrorScreen = false;
            const isIQAParameterAllowed = (state.personaConfiguration && state.personaConfiguration.shouldEnableAdditionalOption) || false;
            if (results && results.length) {
                const resultDataIQA = results[0];
                if (resultDataIQA.error && resultDataIQA.error.code) {
                    errorMessage = SERVICE_FAIL_STATUS;
                    shouldShowIQAErrorScreen = true;
                }
                else {
                    const metrics = resultDataIQA.metrics;
                    imageDetailPayload = {
                        brightnessScore: (metrics && metrics.brightness.score) || 0,
                        contrastScore: (metrics && metrics.contrast.score) || 0,
                        blurScore: (metrics && metrics.blur.score) || 0,
                        gammaScore: (metrics && metrics.gamma.score) || 0,
                        noiseScore: (metrics && metrics.noise.score) || 0
                    };
                    if (!isIQAParameterAllowed) {
                        shouldShowIQAErrorScreen = !hasImageQualityAnalysisIsClear(imageDetailPayload);
                    }
                }
            }
            // Use the function to determine the current view of the screen
            const currentView = determineStateView(state.screenName || EMPTY_TEXT, isIQAParameterAllowed, shouldShowIQAErrorScreen, state.view || IntelligentPhotoCaptureViewType.NONE);
            return Object.assign(Object.assign({}, state), { imageDetailsData: imageDetailPayload, serviceFailStatus: errorMessage, view: currentView, lastRenderedView: IntelligentPhotoCaptureViewType.PREVIEW });
        }
        case PHOTO_CAPTURE_INTELLIGENT_RESET_IMAGE_ANALYZER_DETAILS: {
            return Object.assign(Object.assign({}, state), { imageDetailsData: {}, serviceFailStatus: EMPTY_TEXT });
        }
        case PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { serviceFailStatus: SERVICE_FAIL_STATUS, imageDetailsData: {} });
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentImageDetailsReducer.js.map